import React from "react";
import Navbar from "components/generales/Navbar";
import FiltrosBalanceCuenta from "./FiltrosBalanceCuenta";

import './Balance.css'
import enConstruccion from '../../components/generales/under_constructions.png'

//En construcción, hay que reestructurar componentes y funciones
const BalanceCuenta = () => {
  return (
    <>
      <Navbar />
      <div className="lista-preview">
        <h2>Balance por Cuenta</h2>
        <p className="parrafo">Consulta el estado de tus cuentas</p>
        <FiltrosBalanceCuenta />
        <img src={enConstruccion} alt="" />
      </div>;
    </>
  )
};

export default BalanceCuenta;
